import { camelToKebab } from '@web-platform/shared-universal-constants/src/queryParamMapper';

import type { SearchParams } from '@skyscanner-internal/global-components/flights-search-controls';
import type { FareAttributes } from '@skyscanner-internal/global-components/flights-search-controls/common/constants/fareAttributes';
import type { SearchState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

const getInitialSearchState = (
  userSearch: SearchState,
  shouldPerformParallelSearch: boolean = false,
  shouldPerformPackagesParallelSearch: boolean = false,
): SearchParams => {
  const {
    adults,
    alternativeDestinations,
    alternativeOrigins,
    cabinClass,
    child_ages,
    fareAttributes,
    legs,
    options,
    prefer_directs,
    tripType,
    version,
  } = userSearch;

  return {
    version,
    adults,
    alternativeDestinations,
    alternativeOrigins,
    cabinClass,
    child_ages,
    fareAttributes: (fareAttributes?.map(camelToKebab) ?? []) as FareAttributes[],
    legs,
    options,
    prefer_directs,
    tripType,
    shouldPerformParallelSearch,
    shouldPerformPackagesParallelSearch,
  };
};

export default getInitialSearchState;
